import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "orders",
    object: "order",
    header: [
      { text: "ID", value: "id" },
      { text: "Store", value: "store_id" },
      { text: "Status", value: "status" },
      { text: "Guard", value: "guard_id" },
      { text: "Date", value: "date_timezone" },
      { text: "Total", value: "total" },
      { text: "Sub Total", value: "sub_total" },
      { text: "Discount", value: "discount" },
      { text: "Items", value: "products_actions" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    note_statuses: {
      1: 'All items scanned and paid for',
      2: '1 items was not scanned or paid for',
      3: '2 or more items were not scanned or paid for',
    }
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getDiscountTotal({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");

        let filter = {
          ...options,
          search: ""
        };

        axios
          .get(config.api_url + "total_discount", { params: filter })
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    },
    getBestSellingProduct({ commit, state }, options) {      
      return new Promise((resolve, reject) => {
        commit("request");

        let filter = {
          ...options,
          search: ""
        };

        axios
          .get(config.api_url + "best_selling_product", { params: filter })
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    }
  },
  getters: {
    ...genericStore.getters,
  },
  methods: {
    getNoteStatus(status) {
      let note_statuses = {
        1: 'All items scanned and paid for',
        2: '1 items was not scanned or paid for',
        3: '2 or more items were not scanned or paid for',
      };
      return note_statuses[status];
    }
  }
};
